export enum Network {
  DEVNET = 'sui:devnet',
  TESTNET = 'sui:testnet',
  MAINNET = 'sui:mainnet',
}

export const ZERO_ADDRESS =
  '0x0000000000000000000000000000000000000000000000000000000000000000';

export const OBJECT_RECORD = {
  [Network.DEVNET]: {
    IPX_PACKAGE_ID:
      '0x7526f2ab7890276a8bdf4c3167683e2df079781fc3c3a6e1e0bdb95722014954',
    IPX_STORAGE:
      '0xa12806b9e0e9084e9fff6f91801a5d8fdc89429430eea5b144e5cc17cc460f77',
    DEX_PACKAGE_ID:
      '0x1cab93480403e420a84c96340d8917810e8736e1f2348202a58ee3b3ae022ae7',
    DEX_POOLS:
      '0x0f4d2db07a149879904bb6f745c3dbfe2b3ef5c496ee86f7d66f591f93efbf56',
    DEX_CORE_STORAGE:
      '0x92cd50d2735086963fa9c3dc0e7c7c3a294403fbc7d907066e0e1b0420031f46',
    DEX_MASTER_CHEF_STORAGE:
      '0x1c216dae931af6595ff8310364aa608a9f8156f875c918fb4945f8a2b7fa3463',
    DEX_MASTER_CHEF_ACCOUNT_STORAGE:
      '0x16bc6513fec89419eb1a35ab07a80eb50ccf5985edc096a3a82afb49e0c13e25',
    FAUCET_PACKAGE_ID:
      '0x3821e4ae13d37a1c55a03a86eab613450c1302e6b4df461e1c79bdf8381dde47',
    FAUCET_BTC_STORAGE:
      '0xa485bbfe47077f1739970f8cd51af5485d108888f8b66d57e3c33ed679080a7c',
    FAUCET_ETH_STORAGE:
      '0x5e6e1dc724b631971a93825e6115cafd91bfcc4bd7bf6cfaff73c812656bb638',
    FAUCET_BNB_STORAGE:
      '0x7eed788550fd3edc957298a337eaf4b26ccbf3a977b2ff15781ef8dc72d7eb12',
    FAUCET_USDC_STORAGE:
      '0xb77710e571f53eb4dfa1fe5fb365505ecd560a484f57e6a8a55b1c4a84c9d3c4',
    FAUCET_USDT_STORAGE:
      '0xd4133d334c351611a05428b4b9b56a18abc67492dc5b7d5feae4a8ea6cf36d89',
    DEX_QUOTE_PACKAGE_ID:
      '0xfe3d9d1fbc06b915e9a546b9d38a3e622850fe77cb198f3d8f822f919365a8b9',
  },
  [Network.TESTNET]: {
    IPX_PACKAGE_ID:
      '0x57e5622e674c7fd98303516920ac4250a0667e486e3617f71c8b448f1b032aed',
    IPX_STORAGE:
      '0x4aebcc39ce03cab35c2ef3635aa68d99320f69febe0596e7d61695313f2190d6',
    DEX_PACKAGE_ID:
      '0xd15fcc9307dcf822a6ec40950b8b8331ae2367c4455c568296ed4e1eb8527a75',
    DEX_POOLS:
      '0x4637ab864aaee41bfa12f0ebf5588d1e91a753f43fe46303f6d93f57d151bd05',
    DEX_CORE_STORAGE:
      '0x065a58d3e0e41717c7d0b08d09928b2251d3f8f8b0d1479f092e15635969b8be',
    DEX_MASTER_CHEF_STORAGE:
      '0xefc82c6a4d8b6d1b2e6421fa7640e0befb14c8f7e862360b948cbff0fbd5fba3',
    DEX_MASTER_CHEF_ACCOUNT_STORAGE:
      '0xdf5cef4c924f0cbd874ff12a2a7aa32673c9f80722fd781cc66fab11bdf155eb',
    FAUCET_PACKAGE_ID:
      '0xb8656a09a489819f07c444cb4a4a61a3b482a5ea994fd71b0a643ffc1c2f2dd0',
    FAUCET_BTC_STORAGE:
      '0xdec9b16bb03b140e3102042ad502e1debbe7d91fd347e0110d7ed72d269da0ae',
    FAUCET_ETH_STORAGE:
      '0x42ff0f1c48ed73b238e32d29552157f7d4961c52ca5175ceeef6301425d8dcf8',
    FAUCET_BNB_STORAGE:
      '0x15b454ee4546ddb49ef42e67167f71fac8406961a51dc28529e235669a7d136c',
    FAUCET_USDC_STORAGE:
      '0xa08c1f969d36beba75637f771f89943856f69cef8be540a867e80ec6047ded1e',
    FAUCET_USDT_STORAGE:
      '0xf80e06b35dad3ba0094db29ae89488b81a68e1e9746fad5c98c3dc67c4a0827c',
    DEX_QUOTE_PACKAGE_ID:
      '0xfe3d9d1fbc06b915e9a546b9d38a3e622850fe77cb198f3d8f822f919365a8b9',
  },
  [Network.MAINNET]: {
    IPX_PACKAGE_ID:
      '0x49d87b9af35c4fef28def2cd65884aa9c49bb4eedbcee647f4dafb5c8f36ba57',
    IPX_STORAGE:
      '0xd3c1e174400409c2613559f0309d82fb2a97a1bbc77d6ea39aa1e11f4f6d67d1',
    DEX_PACKAGE_ID:
      '0x5c45d10c26c5fb53bfaff819666da6bc7053d2190dfa29fec311cc666ff1f4b0',
    DEX_POOLS:
      '0x108779144605a44e4b5447118b711f0b17adf6168cc9b08551d33daca58098e3',
    DEX_CORE_STORAGE:
      '0xdf2ee39f28fdf4bc5d5b5dc89926ac121839f8594fa51b2383a14cb99ab25a77',
    DEX_MASTER_CHEF_STORAGE:
      '0xbf3574ae177272809a7ee8f16c68db8fb832d4b10cb5febc477f90baba5ab6dd',
    DEX_MASTER_CHEF_ACCOUNT_STORAGE:
      '0x23fd9726a20709b6f3a59ba676a1d7bfede607ebeb011f888bb33de4f8f44e32',
    // THERE IS NO FAUCET ON MAINNET
    FAUCET_PACKAGE_ID:
      '0x0000000000000000000000000000000000000000000000000000000000000000',
    FAUCET_BTC_STORAGE:
      '0x0000000000000000000000000000000000000000000000000000000000000000',
    FAUCET_ETH_STORAGE:
      '0x0000000000000000000000000000000000000000000000000000000000000000',
    FAUCET_BNB_STORAGE:
      '0x0000000000000000000000000000000000000000000000000000000000000000',
    FAUCET_USDC_STORAGE:
      '0x0000000000000000000000000000000000000000000000000000000000000000',
    FAUCET_USDT_STORAGE:
      '0x0000000000000000000000000000000000000000000000000000000000000000',
    DEX_QUOTE_PACKAGE_ID:
      '0xd3f17406b17aa93f634e486a76938532e49f04345e59c3d250c9ebce79a0263f',
  },
};

export enum DexFunctions {
  SwapX = 'swap_x',
  SwapY = 'swap_y',
  OneHopSwap = 'one_hop_swap',
  TwoHopSwap = 'two_hop_swap',
}

export const DEX_FUNCTION_TO_GET_AMOUNT_FUNCTION_MAP = {
  [DexFunctions.SwapX]: 'quote_swap_x',
  [DexFunctions.SwapY]: 'quote_swap_y',
  [DexFunctions.OneHopSwap]: 'quote_one_hop_swap',
  [DexFunctions.TwoHopSwap]: 'quote_two_hop_swap',
};

export interface Pool {
  token0Balance: string;
  token1Balance: string;
  lpCoinSupply: string;
  lpCoin: string;
  poolType: string;
  stable: boolean;
  token0Type: string;
  token1Type: string;
}

export const DEFAULT_POOL: Pool = {
  token0Balance: '0',
  token1Balance: '0',
  lpCoinSupply: '0',
  lpCoin: '',
  poolType: '',
  token0Type: '',
  token1Type: '',
  stable: false,
};
